import React, { useState } from "react";

export default function AgentPaymentFiltter({ onFilter }) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    if (onFilter && typeof onFilter === "function") {
      onFilter({ fromDate, toDate });
    }
  };

  return (
    <div className="filtercont">
      <div className="row">
        <div className="col-lg-10">
          <div className="row">
            <div className="col-12 col-sm-3 pr-lg-0">
              <label>From Date</label>
              <input
                type="date"
                name="fromDate"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="col-12 col-sm-3 pr-lg-0">
              <label>To Date</label>
              <input
                type="date"
                name="toDate"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <div className="col-lg-2">
              <label>&nbsp;</label>
              <button
                className="btn btn-default submit sitebtn"
                type="button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
